<template>
	<div>
		<n-bread v-bind:content="{bread_list, bread_active}"></n-bread>

		<div class="row">
			<div class="col">
				<n-starred></n-starred>
			</div>
		</div>
	</div>
</template>
<script>
	import NStarred from '@/partials/dashboard/starred_buildings'
	import NBread from '@/partials/bread'
	import { mapActions, mapState, mapMutations } from 'vuex'

	export default {
		data() {
			return {}
		},
		components: {
			NBread,
			NStarred,
		},
		created() {
			this.lang = window.localStorage.getItem("language");
    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Mis operaciones" },
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Le mie operazioni" },
      });
    }
		},
		computed: {
			...mapState('n_dashboard', ['bread_active', 'bread_list']),
		},

		methods: {
			...mapMutations('n_dashboard', ['SET_DATA']),
		},
	}
</script>